import { SVGProps } from "react";

const ResetIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_728_5817)">
        <g clipPath="url(#clip1_728_5817)">
          <mask
            id="mask0_728_5817"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="-1"
            width="12"
            height="13"
          >
            <path
              d="M0.375 -0.399994H11.625V11.6H0.375V-0.399994Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_728_5817)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.01562 5.60001C2.01562 3.55694 3.63994 1.85001 5.70347 1.85001C6.75994 1.85001 7.70705 2.30059 8.3768 3.01707C8.59008 3.24527 8.77481 3.50001 8.92598 3.7753L8.26191 3.61789C7.88283 3.52803 7.50722 3.78298 7.42298 4.18733C7.33875 4.59168 7.57777 4.99231 7.95684 5.08216L10.0662 5.58216C10.4083 5.66326 10.7541 5.46331 10.8771 5.11336L11.5802 3.11337C11.7166 2.72553 11.5324 2.29322 11.1688 2.14778C10.8052 2.00234 10.3999 2.19884 10.2635 2.58669L10.1228 2.98707C9.91345 2.61175 9.66089 2.26639 9.37261 1.95798C8.44378 0.964286 7.14028 0.350006 5.70347 0.350006C2.91685 0.350006 0.609375 2.67252 0.609375 5.60001C0.609375 8.52751 2.91685 10.85 5.70347 10.85C6.99947 10.85 8.18723 10.3502 9.0892 9.52281C9.56986 9.08196 9.97027 8.54726 10.2625 7.94456C10.4409 7.57666 10.3059 7.12416 9.96103 6.93386C9.61608 6.74356 9.19186 6.88751 9.01345 7.25546C8.80608 7.68311 8.51981 8.06676 8.17233 8.38551C7.52058 8.98331 6.65663 9.35001 5.70347 9.35001C3.63994 9.35001 2.01562 7.64306 2.01562 5.60001Z"
              fill="#6C757D"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_728_5817">
          <rect width="12" height="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_728_5817">
          <rect
            width="11.25"
            height="12"
            fill="white"
            transform="translate(0.375 -0.399994)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ResetIcon;
